export default __webpack_public_path__ + "static/media/1_12_logo.f89383e5.png";